.MemberLabelColumnHeading {
  min-width: 180px;
  vertical-align: middle;
}

.EventColumnHeading {
  min-width: 48px;
  text-align: center;
  vertical-align: bottom;

  & > div {
    align-items: center;
    display: inline-flex;
    height: 180px;
    justify-content: flex-start;
    line-height: 1.1;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
  }
}

.MemberColumnHeading {
  min-width: 48px;
  text-align: center;
  vertical-align: bottom;

  & > div {
    align-items: center;
    display: inline-flex;
    height: 180px;
    justify-content: flex-start;
    line-height: 1.1;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
  }
}

.EventColumnSubHeading {
  font-size: 11px;
  font-weight: 400;
  overflow-wrap: anywhere;
  text-align: center;
  width: 48px;
}

.BookingCell {
  font-weight: 600;
  min-width: 48px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.LegendItem {
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
}
